import React, { useEffect } from 'react';
import { Header, Icon, Image, Button } from 'semantic-ui-react';
import './SlideInPanel.css';
import { FaTimes } from 'react-icons/fa';

/**
 * SlideInPanel Component
 * A reusable slide-in panel that appears from the right side of the screen
 * Used for forms and other interactive content
 */
const SlideInPanel = ({
  isOpen,
  onClose,
  title,
  children,
  width = '600px',
  showOverlay = true,
  headerImg = {}
}) => {
  // Handle escape key to close panel
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when panel is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      {showOverlay && (
        <div
          className="slide-panel-overlay"
          onClick={onClose}
        />
      )}

      {/* Panel */}
      <div
        className={`slide-panel ${isOpen ? 'open' : ''}`}
        style={{ width }}
      >
        {/* Panel Header */}
        <div className="slide-panel-header">
          <Header as="h3">
            <Image src={headerImg} />
            <span className='book-creator-state-manager-list-header'>{title}</span>

            <Button
              icon
              basic
              circular
              onClick={onClose}
              className="closeButton"
            >
              <FaTimes className="closeIcon" />
            </Button>
          </Header>
        </div>

        {/* Panel Content */}
        <div className="slide-panel-content">
          {children}
        </div>
      </div>
    </>
  );
};

export default SlideInPanel;
